import React from 'react';
import { Grid, Image, Typography } from 'antd';
import '../Styles/Linkages&Outreach.css'; 
import AppHeader from '../Layout/Header';
import LatestUpdates from '../Components/LinkagesComponent/L&O Components/LatestUpdates';
import SpaceAwarenessProgram from '../Components/LinkagesComponent/L&O Components/SpaceAwarenessProgram';
import TrainingWorkshops from '../Components/LinkagesComponent/L&O Components/TrainingWorkshops';
import LinkagesCollaborations from '../Components/LinkagesComponent/L&O Components/LinkagesCollaboration';
import FooterComponent from '../Layout/Footer';
import FooterQuote from '../Layout/FooterQuote';
import ncgsaCollaborationImage from '../Assets/Linkages/NCGSA-Collaboration.png';
import InternationalConferences from '../Components/LinkagesComponent/L&O Components/InteranationalConferences';

const { Paragraph } = Typography;
const { useBreakpoint } = Grid;


const LinkagesandOutreach = () => {
    const screens = useBreakpoint();
  return (
    <>
      <AppHeader />
      <div className="linkages-page">
        <div
          className="banner-container"
          role="img"
          aria-label="Linkages and Capacity Building"
        />

      <section className="linkages-intro-section">
        <div className="linkages-intro-content">
          <Paragraph style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} className="description">
            The National Centre for GIS and Space Applications (NCGSA) places a strong emphasis on strategic collaboration as a cornerstone for advancing space science, technology, and its applications. Acknowledging that meaningful progress stems from the integration of diverse expertise, NCGSA has established a broad network of partnerships with leading national and international academic institutions, research organizations, and industry stakeholders. These collaborations support the development and deployment of cutting-edge solutions addressing critical challenges in environmental monitoring, urban planning, disaster management, agriculture, and infrastructure development. In tandem with collaborative research, comprehensive space awareness and outreach programs are implemented to engage diverse audiences. By maintaining these long-term, mutually advantageous relationships, NCGSA reaffirms its commitment to positioning GIS and space technologies as vital instruments for sustainable development, economic advancement, and societal resilience both within Pakistan and across the international landscape.
          </Paragraph>
          <div className="linkages-intro-image-wrap">
            <Image
            preview={false}
              className="linkages-intro-image"
              src={ncgsaCollaborationImage}
              alt="National Centre for GIS and Space Applications"
            />
          </div>
        </div>
      </section>
      <main className="page-content-bands">
        <section><LatestUpdates/></section>
        <section><SpaceAwarenessProgram/></section>
        <section><TrainingWorkshops/></section>
        <section><InternationalConferences/></section>
        <section><LinkagesCollaborations/></section>
      </main>
 </div>
      <FooterQuote
        variant="linkages"
        quote="He has subjected for you the night and day and the sun and moon, and the stars are subjected by His command."
        attribution="Qur’an 16:12"
      />
      <FooterComponent/>
    </>
  );
};

export default LinkagesandOutreach;
